<template>
  <swiper
    :slidesPerView="'auto'"
    :spaceBetween="10"
    :pagination="{
      clickable: true,
    }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    class="filter react"
    id="container"
  >
    <swiper-slide>
      <p
        v-if="categoryType != 'productsCategory'"
        @click="callSelectedCategory('', $event)"
        class="selected_category"
      >
        همه
      </p>
    </swiper-slide>
    <template v-for="(categoryItem, index) in categoryList" :key="index">
      <swiper-slide>
        <a
          v-if="categoryType == 'productsCategory'"
          :href="'#' + categoryItem.category_name"
        >
          {{ categoryItem.category_name }}
        </a>
        <p
          v-else
          @click="callSelectedCategory(categoryItem.category_name, $event)"
        >
          {{ categoryItem.category_name }}
        </p>
      </swiper-slide>
    </template>
    <swiper-slide v-if="managerMode == 'dataEdit'">
      <p class="new_category">دسته بندی جدید</p>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { mapGetters } from "vuex";
import "swiper/css";
export default {
  name: "categorySliderReact",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    categoryList: Array,
    categoryType: String,
  },
  methods: {
    callSelectedCategory(selected, eve) {
      const elems = document.getElementsByClassName("selected_category");
      [].forEach.call(elems, function (el) {
        el.classList.remove("selected_category");
      });
      eve.target.classList.add("selected_category");
      this.$emit("selectedCategory", selected);
    },
  },
  computed: {
    ...mapGetters({
      managerMode: "managerMode",
    }),
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/categorySlider/categorySlider.css);
</style>